import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
} from "reactstrap";

const UserDetailsModal = ({ isOpen, toggle, user, loading, error }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered scrollable size="lg">
      <ModalHeader
        className="d-flex align-items-center"
        toggle={toggle}
        style={{ background: "#E0F8E0" }}
      >
        Admin Details
      </ModalHeader>
      <ModalBody>
        {loading && <p className="text-muted">Loading...</p>}
        {error && <p className="text-danger">Error: {error}</p>}

        {user && (
          <>
            {/* TOP PROFILE SECTION */}
            <div className="text-center mb-4">
              {/* PROFILE IMAGE OR INITIALS */}
              {user?.profilePic ? (
                <img
                  src={user?.profilePic}
                  alt="Profile"
                  className="img-thumbnail rounded-circle"
                  style={{
                    height: "150px",
                    width: "150px",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle bg-success text-white fw-bold"
                  style={{
                    height: "150px",
                    width: "150px",
                    fontSize: "48px",
                    margin: "0 auto",
                  }}
                >
                  {user?.name
                    ?.split(" ")
                    .filter(Boolean)
                    .map((word) => word[0])
                    .join("")
                    .toUpperCase()}
                </div>
              )}

              {/* NAME */}
              <h4 className="fw-semibold mt-3">{user?.name}</h4>
              <Badge
                color={user?.active ? "success" : "danger"}
                className="mt-2"
              >
                {user?.active ? "Active" : "Inactive"}
              </Badge>
            </div>

            {/* DETAILS SECTION */}
            <Row className="mt-4 px-2">
              {/* LEFT COLUMN */}
              <Col md={6} className="mb-3">
                <p className="mb-2">
                  <strong>Email:</strong> {user?.email}
                </p>
                <p className="mb-2">
                  <strong>Mobile No:</strong> {user?.mobileNo}
                </p>
                <p className="mb-2">
                  <strong>Secondary Mobile:</strong> {user?.mobileSecNo || "-"}
                </p>
                <p className="mb-2">
                  <strong>State:</strong> {user?.state || "-"}
                </p>
                <p className="mb-2">
                  <strong>Address:</strong> {user?.address}
                </p>
              </Col>

              {/* RIGHT COLUMN */}
              <Col md={6} className="mb-3">
                <p className="mb-2">
                  <strong>GST Number:</strong> {user?.gstnNo}
                </p>
                <p className="mb-2">
                  <strong>PAN Number:</strong> {user?.panNo}
                </p>
                <p className="mb-2">
                  <strong>Registration Date:</strong> {user?.registrationDate}
                </p>
                <p className="mb-2">
                  <strong>Start Date:</strong> {user?.startDate}
                </p>
                <p className="mb-2">
                  <strong>Expiry Date:</strong> {user?.expiryDate}
                </p>
              </Col>
            </Row>
          </>
        )}
      </ModalBody>

      <ModalFooter>
        <Button color="success" className="btn-sm" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UserDetailsModal;
